import { useState } from 'react';
import ToolsOpt from '../../components/seo/ToolsOpt';
import "./FileConverter.css";
import { FaUpload, FaDownload } from "react-icons/fa";

export default function FileConverter() {
    const [input, setInput] = useState(null);
    const [convertedFile, setConvertedFile] = useState(null);     
    const [convertedFilename, setConvertedFilename] = useState(""); 
    const [error, setError] = useState("");
    const [uploadStatus, setUploadStatus] = useState("");

    const handleChange = (e) => {
        const file = e.target.files[0];
        setError("");
        setUploadStatus("");
        setConvertedFile(null);
        setConvertedFilename("");

        if (!file) {
            setInput(null);
            return;
        }

        setInput(file);
    };

    
    const convertFile = async (endpoint) => {
        if (!input) {
            setError("Please select a file first.");
            return;
        }

        setError("");
        setConvertedFile(null);
        setUploadStatus("Converting...");

        const data = new FormData();
        data.append("file", input);

        try {
            const response = await fetch(`https://api.explorelrt.com/${endpoint}`, {
                method: "POST",               
                body: data
            });

            const output = await response.json();

            if (!response.ok || output.error) {
                setError(output.error || "Failed to convert file.");
                setUploadStatus("");
                return;
            }

            
            const fileData = output.file;

            setConvertedFile(fileData);
            setConvertedFilename(output.filename || "converted_file");
            setUploadStatus("Conversion successful!");

        } catch (err) {
            console.error("Error converting file:", err);
            setError("Failed to connect to the server.");
            setUploadStatus("");
        }
    };

    
    const downloadFile = (dataUrl, filename) => {
        if (!dataUrl) return;
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    
    const isImage = convertedFilename.endsWith('.png') || 
                    convertedFilename.endsWith('.jpg') || 
                    convertedFilename.endsWith('.jpeg') || 
                    convertedFilename.endsWith('.heic') || 
                    convertedFilename.endsWith('.heif');

    
    const isPdf = convertedFilename.endsWith('.pdf');



    return (
        <>
            <ToolsOpt
                title="File Converter"
                description="This is your go-to app for converting file types instantly on your device."
                keywords="File, File Converter, PDF, JPEG, JPG, PNG, DOCX"
            />
            <h1 style={{margin:"10%", display:"flex", justifyContent:"center"}}> Explorelrt File Conversion</h1>

            <div className='converterContainer'>
                <div className='inputContainer'>
                    <p>Upload file to convert</p>
                    <div>
                        <input
                            className='input'
                            type="file"
                            onChange={handleChange}
                        />
                        <FaUpload className='uploadIcon' />
                    </div>
                    {input && <p className="selected-file">Selected: {input.name}</p>}
                </div>

                
                <div className='buttonContainer'>
                    <button onClick={() => convertFile("jpgtopng")}>
                        JPG to PNG
                    </button>
                    <button onClick={() => convertFile("heictojpg")}>
                        HEIC to JPG
                    </button>
                    <button onClick={() => convertFile("heictopng")}>
                        HEIC to PNG
                    </button>
                    <button onClick={() => convertFile("txttopdf")}>
                         TXT to PDF
                    </button>
                    <button onClick={() => convertFile("docxtopdf")}>
                         DOCX to PDF
                    </button>
                </div>

                
                <div className='outputContainer'>
                    {error && <p className="error-text" style={{ color: 'red' }}>{error}</p>}
                    {uploadStatus && <p className="status-text">{uploadStatus}</p>}

                    
                    {convertedFile && (
                        <div className="preview-box">
                            
                            {isImage && (
                                <img 
                                    src={convertedFile} 
                                    alt="Converted Preview" 
                                    style={{ maxWidth: '320px', borderRadius: '8px' }} 
                                />
                            )}

                            
                            {isPdf && (
                                <iframe 
                                    src={convertedFile} 
                                    title="PDF Preview" 
                                    width="100%" 
                                    height="400px" 
                                    style={{ border: '1px solid #ccc', borderRadius: '8px' }}
                                />
                            )}

                            <br />
                            
                            <button 
                                className="download-btn"
                                onClick={() => downloadFile(convertedFile, convertedFilename)}
                            >
                                <FaDownload /> Download {convertedFilename}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
